import { isPrivateConnectionsPath } from '@/shared/constants/routes';
import type { NavItem } from '@/viewmodel/shared/sidebar/types';

const PRIVATE_CONNECTIONS_KEY = 'private-connections';

export function gateByPermission<P extends string, T extends NavItem<P>>(
  items: T[],
  can: (permission: P) => boolean,
  disabledTip: string,
): T[] {
  const denied = (item: T): boolean =>
    item.requiredPermission !== undefined && !can(item.requiredPermission);

  return items
    .filter((item) => !(denied(item) && item.hideWhenDenied))
    .map((item) => (denied(item) ? { ...item, disabled: true, disabledTip } : item));
}

export function activeNavKey(items: readonly NavItem[], pathname: string): string | undefined {
  if (
    isPrivateConnectionsPath(pathname) &&
    items.some((item) => item.key === PRIVATE_CONNECTIONS_KEY)
  ) {
    return PRIVATE_CONNECTIONS_KEY;
  }
  const exact = items.find((item) => item.path === pathname);
  if (exact) return exact.key;
  return items.find(
    (item) => item.path !== undefined && item.path !== '/' && pathname.startsWith(`${item.path}/`),
  )?.key;
}
